<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>Resumen por asesor
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <div class="row">
          <div class="form-group col-lg-6">
            <label>Asesor reserva
              <ng-container *ngIf="employeeSelected == null">
                (<span class="f-s-11">empleado</span>)
              </ng-container>
              <ng-container *ngIf="employeeSelected != null">
                (<span class="f-s-11">{{employeeSelected.jobassigned}}</span>)
              </ng-container>
              <span class="required"></span>
            </label>
            <ng-container *ngIf="employeeSelected != null">
              <div class="input-group">
                <input type="text" class="form-control form-control-sm" disabled value="{{employeeSelected.fullname}}">
                <div class="input-group-append bg-custom b-0 removeClient">
                  <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                    (click)="removeEmployee()">
                    <i class="fas fa-backspace w-100 f-s-12"></i>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="employeeSelected == null">
              <component-search-employee [classSize]="'search-small'"
                (selectedEmployeeEvent)="selectedEmployeeSearch($event)" class="w-100">
              </component-search-employee>
            </ng-container>
          </div>
          <!-- <div class="form-group col-lg-3">
            <label>Estado</label>
            <select class="form-control">
              <option value="0">Todos</option>
              <option value="1">Confirmados</option>
              <option value="2">Anulados</option>
            </select>
          </div> -->
        </div>
        <div class="row m-t-15">
          <ng-container *ngIf="!generate">
            <div class="col-lg-12">
              <p class="f-s-14 text-center">Seleccionar opción para cargar vista <i class="fas fa-table m-l-5"></i></p>
            </div>
          </ng-container>
          <ng-container *ngIf="generate">
            <div class="col-lg-12">
              <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                  <a class="nav-link pointer" [class.active]="activeTab === 'home'" (click)="setActiveTab('home')"
                    role="tab">
                    <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
                    <span class="d-none d-sm-block">Lista reservas</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link pointer" [class.active]="activeTab === 'historymonth'"
                    (click)="setActiveTab('historymonth')" role="tab">
                    <span class="d-block d-sm-none"><i class="far fa-user"></i></span>
                    <span class="d-none d-sm-block">Histórico reservas anual(x Mes)</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link pointer" [class.active]="activeTab === 'historytours'"
                    (click)="setActiveTab('historytours')" role="tab">
                    <span class="d-block d-sm-none"><i class="far fa-user"></i></span>
                    <span class="d-none d-sm-block">N° PAX (x Tours)</span>
                  </a>
                </li>
                <!-- 
                    <li class="nav-item">
                      <a class="nav-link" 
                         [class.active]="activeTab === 'messages'" 
                         (click)="setActiveTab('messages')" 
                         role="tab">
                        <span class="d-block d-sm-none"><i class="far fa-envelope"></i></span>
                        <span class="d-none d-sm-block">Messages</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" 
                         [class.active]="activeTab === 'settings'" 
                         (click)="setActiveTab('settings')" 
                         role="tab">
                        <span class="d-block d-sm-none"><i class="fas fa-cog"></i></span>
                        <span class="d-none d-sm-block">Settings</span>
                      </a>
                    </li> -->
              </ul>
              <div class="tab-content p-t-10 text-muted">
                <div class="tab-pane" [class.active]="activeTab === 'home'" role="tabpanel">
                  <div class="row m-b-10">
                    <div class="col-lg-8">
                      <button type="button" class="btn btn-light m-r-5" title="Actualizar" (click)="refresh()">
                        <i class="fas fa-undo"></i></button>
                      <div class="content__subhead__inputGrid m-r-5">
                        <div class="input-group" style="width: auto;">
                          <span class="input-group-prepend">
                            <span class="input-group-text content__subhead__inputGrid__title">
                              <i class="far fa-calendar-alt m-r-5"></i> Fecha registro
                            </span>
                          </span>
                          <input type="text" id="date_range" class="form-control content__subhead__inputGrid__input">
                        </div>
                      </div>
                      <div class="content__subhead__inputGrid m-r-5">
                        <div class="input-group" style="width: auto;">
                          <span class="input-group-prepend">
                            <span class="input-group-text content__subhead__inputGrid__title">
                              Estado
                            </span>
                          </span>
                          <select class="form-control content__subhead__inputGrid__input" [(ngModel)]="statusBooking"
                            [ngModelOptions]="{standalone: true}">
                            <option value="0">Todos</option>
                            <option value="1">Confirmados</option>
                            <option value="2">Anulados</option>
                          </select>
                        </div>
                      </div>
                      <button class="btn btn-primary btn-sm" (click)="list()">
                        <i class="fas fa-search m-r-3"></i>Generar
                      </button>
                    </div>
                    <div class="col-lg-4 text-right">
                      <ng-container *ngIf="items.length > 0">
                        <div class="content__subhead__inputGrid">
                          <div class="input-group">
                            <span class="input-group-prepend">
                              <span class="input-group-text content__subhead__inputGrid__title">
                                Total
                              </span>
                            </span>
                            <input type="text" class="form-control content__subhead__inputGrid__input text-center"
                              value="{{items.length}}" style="width: 50px !important;" disabled>
                          </div>
                        </div>
                        <a class="btn btn-outline-danger btn-sm f-s-10" target="_blank"
                          href="/{{branchofficeSlug}}/api/report/bookings/summary_adviser?employee_id={{params.employee_id}}&status_booking={{statusBooking}}&start_range={{start_range.format('YYYY-MM-DD')}}&end_range={{end_range.format('YYYY-MM-DD')}}&export_pdf=true/"><i
                            class="far fa-file-pdf m-r-3"></i>Exportar PDF</a>
                      </ng-container>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table class="table table-hover table-sm mb-0">
                      <thead class="thead-default">
                        <tr>
                          <th>N° reserva</th>
                          <th><span class="f-s-12">Etiqueta</span></th>
                          <th>Reponsable</th>
                          <th class="text-center">N° pax</th>
                          <th class="text-center">Estado</th>
                          <th>Total Paq.</th>
                          <th>Pagado</th>
                          <th class="text-right">Deuda</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngIf="items.length == 0">
                          <td colspan="2"><span>No se encontraron registros</span></td>
                        </ng-container>
                        <ng-container *ngIf="items.length > 0">
                          <tr [ngClass]="{'text-danger': item.is_checkout }" *ngFor="let item of items; let i = index">
                            <td>
                              <p class="grid__link m-b-0">
                                <i *ngIf="item.is_favorite" class="fas fa-star m-r-2 color-favorite"></i> {{item.code}}
                              </p>
                              <p class="bold f-s-10 m-b-0">
                                Reg. : {{item.created_at | date: 'mediumDate'}}</p>
                              <p *ngIf="item.is_book_hotel" class="bold m-b-0 f-s-9">
                                <i class="fas fa-hotel m-r-5" style="color: black !important;"></i>
                                <span class="badge badge-hotel f-s-10">RES. SOLO HOTEL</span>
                              </p>
                            </td>
                            <td>
                              {{item.reference_voucher}}
                            </td>
                            <td>
                              <p class="m-b-0">{{item.client_data.fullname}}</p>
                              <p class="bold f-s-10 m-b-0">{{item.client_data.typeDocument}} :
                                {{item.client_data.document}}</p>
                            </td>
                            <td class="text-center">
                              {{item.nro_pax}}
                            </td>
                            <td class="text-center">
                              <span *ngIf="item.deleted_at != null" class="badge badge-danger f-s-10">Anulado</span>
                              <span *ngIf="item.deleted_at == null"
                                class="badge f-s-10 badge-{{item.status_booking.class}}">{{item.status_booking.message}}</span>
                            </td>
                            <td>
                              {{toolsService.momeySol()}}{{item.total}}
                            </td>
                            <td>{{toolsService.momeySol()}}{{item.total_paid}}</td>
                            <td class="text-right">
                              <ng-container *ngIf="(item.total - item.total_paid) > 0">
                                <span class="text-danger bold">
                                  {{toolsService.momeySol()}}{{(item.total - item.total_paid).toFixed(2)}}
                                </span>
                              </ng-container>
                              <ng-container *ngIf="(item.total - item.total_paid) == 0">
                                <span>-</span>
                              </ng-container>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                  <ng-container>
                    <p class="m-t-20 m-b-10"><i class="fas fa-info-circle m-r-5"></i> RESUMEN TOTALES</p>
                    <div class="table-responsive" *ngIf="items.length > 0">
                      <table class="table table-hover table-sm mb-0">
                        <thead class="thead-default">
                          <tr>
                            <th class="text-center">TOTAL RESERVAS</th>
                            <th class="text-center">TOTAL N° PAX</th>
                            <th class="text-center">TOTAL ACUM. PAQ.</th>
                            <th class="text-center">TOTAL ACUM. PAGADO</th>
                            <th class="text-center">TOTAL ACUM. DEUDA</th>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container *ngIf="items.length == 0">
                            <td colspan="2"><span>Debe indicar los parámetros para acrgar los datos</span></td>
                          </ng-container>
                          <ng-container *ngIf="items.length > 0">
                            <tr>
                              <td class="text-center">
                                {{items.length}}
                              </td>
                              <td class="text-center bold">
                                {{sum_pax}}
                              </td>
                              <td class="text-center">
                                <span class="bold text-success">{{toolsService.momeySol()}}{{sum_total}}</span>
                              </td>
                              <td class="text-center bold">{{toolsService.momeySol()}}{{sum_paid}}</td>
                              <td class="text-center">
                                <span class="text-danger bold">{{toolsService.momeySol()}}{{sum_balance}}</span>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </ng-container>
                </div>
                <div class="tab-pane" [class.active]="activeTab === 'historymonth'" role="tabpanel">
                  <!-- <p class="mb-0">
                    Food truck fixie locavore, accusamus mcsweeney's marfa nulla...
                  </p> -->
                  <div class="row m-t-25">
                    <div class="col-12">
                      <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" [(update)]="updateFlag"
                        style="width: 100%; height: 400px; display: block;">
                      </highcharts-chart>
                    </div>
                  </div>
                </div>
                <div class="tab-pane" [class.active]="activeTab === 'historytours'" role="tabpanel">
                  <div class="row m-b-25">
                    <div class="col-lg-12">
                      <button type="button" class="btn btn-light m-r-5" title="Actualizar" (click)="refresh()">
                        <i class="fas fa-undo"></i></button>
                      <div class="content__subhead__inputGrid m-r-5">
                        <div class="input-group" style="width: auto;">
                          <span class="input-group-prepend">
                            <span class="input-group-text content__subhead__inputGrid__title">
                              <i class="far fa-calendar-alt m-r-5"></i> Fecha asignada
                            </span>
                          </span>
                          <input type="text" id="date_range_tours" class="form-control content__subhead__inputGrid__input">
                        </div>
                      </div>
                      <button class="btn btn-primary btn-sm" (click)="loadDataHistoryTours()">
                        <i class="fas fa-search m-r-3"></i>Generar
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <highcharts-chart [Highcharts]="Highcharts" [options]="tourOptions"
                        style="width: 100%; height: 400px; display: block;">
                      </highcharts-chart>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
